import { Component } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { MenuController } from '@ionic/angular';
import { Router } from '@angular/router';
import { PagesService } from './services/pages.service';
import { GlobalService } from './services/global.service';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { LoggerService } from './services/logger.service';

import { AppUpdateService } from './services/app-update.service';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent
{
    public appPages = [];
    safeUrl!: SafeResourceUrl;

    constructor(
        private nativeStorage: NativeStorage,
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private updater: AppUpdateService,
        private menuController: MenuController,
        private router: Router,
        private pagesService: PagesService,
        private logger: LoggerService,
        public global: GlobalService,
        private sanitizer: DomSanitizer,
        public alertController: AlertController,
        public network: Network
    ) 
    {

        this.initializeApp();
    }



    initializeApp()
    {
        this.platform.ready().then(() =>
        {
            this.platform.ready().then(() => this.updater.checkForUpdate());
            this.statusBar.styleDefault();
            this.splashScreen.hide();
            this.platform.backButton.subscribeWithPriority(10, () =>
            {
                this.logger.log('Boton retroceder pulsado');
                this.showExitConfirm();
            });
            // Get Menus For Side Menu
            this.appPages = this.pagesService.getPages();
        });

        // watch network for a disconnection
        this.network.onDisconnect().subscribe(() =>
        {
            this.logger.log('Aqui red desconectada :-(');
        });

        this.network.onConnect().subscribe(() =>
        {
            setTimeout(() =>
            {
                this.logger.log('Aqui red conectada :-)');
            }, 2000);

        });

    }

    Bot()
    {
        /*const script = document.createElement('script');
        script.src = 'https://chat.overlink.es/app-iframe.php';//?app_token=' + this.global.token + '&app_codigo_cliente=' + this.global.cliente;
        console.log(script.src);
        script.defer = true;
        document.body.appendChild(script);        */

        /*   const url = 'https://chat.overlink.es/app-iframe.php?app_token=' 
               + this.global.token 
               + '&app_codigo_cliente=' 
               + this.global.cliente;
 
   this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);*/
    }

    showExitConfirm()
    {
        this.alertController.create({
            header: 'Salir de la aplicación',
            message: '¿Desea salir de la aplicación?',
            backdropDismiss: false,
            buttons: [{
                text: 'No salir',
                role: 'cancel',
                handler: () =>
                {
                    this.logger.log('Application exit prevented!');
                }
            }, {
                text: 'Salir',
                handler: () =>
                {
                    navigator['app'].exitApp();
                }
            }]
        })
            .then(alert =>
            {
                alert.present();
            });
    }

    // Signout Button
    signout()
    {
        if (this.platform.is('android'))
            navigator['app'].exitApp()
        else
            this.router.navigateByUrl('/signin');

        this.menuController.close(); // cerramos el menú lateral
    }

    executeAction(action: string)
    {
        switch (action)
        {
            case 'logout':
                {
                    this.nativeStorage.setItem('usuarioOv', '')
                        .then(
                            () => { },
                            error => { }
                        );

                    this.nativeStorage.setItem('passwordOv', '')
                        .then(
                            () => { },
                            error => { }
                        );
                    this.router.navigateByUrl('/signin');
                }
                break;
        }
    }
}
